import { Box, Stack, Tab, Tabs } from "@mui/material";
import type { ReactNode } from "react";
import { CampaignsSection } from "Components/WhereToPay/CampaignsSection/CampaignsSection";
import { EShopsSection } from "Components/WhereToPay/EShopsSection/EShopsSection";
import { StoresSection } from "Components/WhereToPay/StoresSection/StoresSection";
import type { WhereToPayTabId } from "Components/WhereToPay/WhereToPayTabs/config";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Pages.Content.WhereToPay.Tabs;

type TabItem = {
  id: WhereToPayTabId;
  label: string;
  content: ReactNode;
  disabled?: boolean;
};

type Props = {
  initialTab: WhereToPayTabId | null;
  onTabChange: (activeTab: WhereToPayTabId) => void;
};

export const WhereToPayTabs = ({ initialTab, onTabChange }: Props) => {
  const { t } = useResource();

  const tabs: Array<TabItem> = [
    {
      id: "shops",
      label: t(RESOURCES.Stores),
      content: <StoresSection />,
    },
    {
      id: "e-shops",
      label: t(RESOURCES.EShops),
      content: <EShopsSection />,
      disabled: true,
    },
    {
      id: "campaigns",
      label: t(RESOURCES.Campaigns),
      content: <CampaignsSection />,
    },
  ];

  const enabledTabs = tabs.filter((tab) => !tab.disabled);
  const activeTab = initialTab || enabledTabs[0]?.id || tabs[0].id;

  return (
    <Stack width="100%">
      <Tabs
        value={activeTab}
        onChange={(_, id: WhereToPayTabId) => onTabChange(id)}
        variant="fullWidth"
        sx={{
          ml: "-12px",
          borderBottom: 1,
          borderColor: "divider",
          width: ["calc(100% + 24px)", "calc(100% + 24px)", "100%"],
        }}
      >
        {tabs.map(({ label, id, disabled }) => (
          <Tab label={label} value={id} key={id} disabled={disabled} />
        ))}
      </Tabs>
      <Box mt="0.5rem" width="100%">
        {tabs.map(({ content, id }) => (
          <div role="tabpanel" hidden={id !== activeTab} key={id}>
            {id === activeTab && content}
          </div>
        ))}
      </Box>
    </Stack>
  );
};
